import { useNavigate } from "react-router-dom";
import ProductCard from "../ProductCard";
import { T } from "../../constants/theme";

export default function ProductGrid({ products }) {
  const navigate = useNavigate();
  return (
    <div className="explore-grid">
      {products.map((product) => {
        const stock = Number(product.stock ?? 0);
        return (
          <div
            key={product.id}
            className="explore-card"
            style={{ border: `1px solid ${T.border}`, borderRadius: 14, overflow: "hidden" }}
          >
            <ProductCard
              product={product}
              onView={(slug) => navigate("/product/" + slug)}
            />
            <div
              style={{
                padding: "0 10px 14px",
                textAlign: "center",
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: ".08em",
                textTransform: "uppercase",
                color: stock > 0 ? "#2d6a4f" : "#c0392b",
              }}
            >
              {stock > 0 ? `In Stock (${stock})` : "Out of Stock"}
            </div>
          </div>
        );
      })}
    </div>
  );
}
